import {Grid} from '@yandex-delivery/blocks'
import React from 'react'

import {useMarginRef} from '../margin-provider'
import {classes} from './styles'

export const MobilePromoContainer: React.FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const ref = useMarginRef<HTMLDivElement>(el => ({
    top: el.offsetHeight,
  }))

  return (
    <Grid className={classes.mobilePromoContainer} ref={ref}>
      {children}
    </Grid>
  )
}
